module.exports = __webpack_public_path__ + "01_mid_black.ed637c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_mid_black.png
// module id = eDaY
// module chunks = 0